module.exports = __webpack_public_path__ + "files/94a02b7d8a0eebfb0e965df5a4dd9449.png";